import { RouteTracker } from './RouteTracker';

const routeTracker = new RouteTracker();

export default routeTracker;
